import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { decryptData } from '../../utils/encrypt';

function Navbar({ onLogout }) {
  const encrypted = localStorage.getItem('suyog_user');
  let user = { user_name: 'User', modules: [], selected_org: null };

  try {
    if (encrypted) {
      const data = decryptData(encrypted);
      user = {
        ...data,
        modules: Array.isArray(data.modules) ? data.modules : [],
        selected_org: data.selected_org || null
      };
    }
  } catch { }

  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem('suyog_user');
    if (onLogout) onLogout();
    navigate('/login');
  };

  const hasAccess = (moduleKey) =>
    Array.isArray(user.modules) && user.modules.includes(moduleKey);

  return (
  <nav className="navbar navbar-expand-lg navbar-dark bg-dark">
  <div className="container-fluid">
    <Link to="/dashboard" className="navbar-brand">Suyog ERP</Link>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navMenu">
      <span className="navbar-toggler-icon"></span>
    </button>

    {/* ⬇ Add padding to collapsible content */}
    <div className="collapse navbar-collapse py-3 py-lg-0" id="navMenu">
         <ul className="navbar-nav me-auto">
            {hasAccess('dashboard') && (
              <li className="nav-item">
                <Link to="/dashboard" className="nav-link">Dashboard</Link>
              </li>
            )}

            {hasAccess('organization') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Organization
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/organization/search">Search</Link></li>
                  <li><Link className="dropdown-item" to="/organization/add">Add New</Link></li>
                </ul>
              </li>
            )}

            {hasAccess('user') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Users
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/user/search">Search</Link></li>
                  <li><Link className="dropdown-item" to="/user/new">Add New</Link></li>
                </ul>
              </li>
            )}

            {hasAccess('account') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Account
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/account/search">Search</Link></li>
                  <li><Link className="dropdown-item" to="/account/new">Add New</Link></li>
                    <li hidden><Link className="dropdown-item" to="/account/access">Account Access</Link></li> 
                    <li hidden><Link className="dropdown-item" to="/account/access_refresh">Account Refresh</Link></li> 
                    <li ><Link className="dropdown-item" to="/account/waba-assignment">Marketing Manager </Link></li> 
                    
                </ul>
              </li>
            )}

            {hasAccess('sales_order') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Sales Order
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/so/search">Search</Link></li>
                  <li><Link className="dropdown-item" to="/so/new">Add New</Link></li>

                  <li><Link className="dropdown-item" to="/dispatch/report/pending">Dispatch Pending Report</Link></li> 
                  <li><Link className="dropdown-item" to="/so/so-plan-dispatch">Sales Order Status Report</Link></li> 
                  <li><Link className="dropdown-item" to="/creditnote/invoicereport">Invoice Report</Link></li>
                </ul>
              </li>
            )}

            {hasAccess('so_planning') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  SO Planning
                </span>
                <ul className="dropdown-menu">
                  <li>
                    <Link className="dropdown-item" to="/soplanning/search">Search</Link>
                  </li>
                  <li>
                    <Link className="dropdown-item" to="/soplanning/setvehicle">SET Vehicle</Link>
                  </li>

                  <li><Link className="dropdown-item" to="/soplanning/new">Add New Planning</Link></li>
                  
                  <li><Link className="dropdown-item" to="/logistics/planning">Add New Logistic Vehicle</Link></li>

                  <li><Link className="dropdown-item" to="/planning/edit">✏️ Edit Planning</Link></li>


                  <li><Link className="dropdown-item" to="/soplanning/close">Close SO Planning</Link></li>
                </ul>
              </li>
            )}


            {hasAccess('billing') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Sales Invoice
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/salesinvoice/search">Search</Link></li>
                   <li><Link className="dropdown-item" to="/creditnote/invoicereport">Add Actual Weight</Link></li>
                </ul>
              </li>
            )}


             {hasAccess('production') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Production
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/production/search">Search</Link></li>
                  <li><Link className="dropdown-item" to="/production/new">Add New</Link></li>
                 <li><Link  className="dropdown-item" to="/production/loadingpointnew">   Manage Loading Point </Link></li>

                  
                </ul>
              </li>
            )}



             {hasAccess('production') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Stock Reports
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/stockreport/stock">Search</Link></li>
                
                  
                </ul>
              </li>
            )}

             {hasAccess('transport') && (
              <li className="nav-item dropdown">
                <span className="nav-link dropdown-toggle" role="button" data-bs-toggle="dropdown">
                  Transporter
                </span>
                <ul className="dropdown-menu">
                  <li><Link className="dropdown-item" to="/transport/search">Search</Link></li>
                  <li><Link className="dropdown-item" to="/transport/new">Add New</Link></li>
                </ul>
              </li>
            )}
          </ul>

          <span className="navbar-text text-white me-3">
            {user.selected_org?.label && (
              <span className="me-3">Current Organization : <strong>{user.selected_org.label}</strong></span>
            )}
            Welcome, {user.user_name}
          </span>

          <button className="btn btn-outline-light btn-sm" onClick={handleLogout}>
            Logout
          </button>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
